module.exports = __webpack_public_path__ + "static/media/beck.b4bf6d21.jpg";